import React from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Typography, Button, Paper, Stack } from '@mui/material';
import { ArrowBack as ArrowBackIcon, Construction as ConstructionIcon } from '@mui/icons-material';

export default function CreateFormInvoice() {
  const history = useHistory();
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f7fafc', py: 8, display: 'flex', justifyContent: 'center' }}>
      <Paper sx={{ p: 6, borderRadius: 3, maxWidth: 480, width: '100%', textAlign: 'center', height: 'fit-content' }}>
        <Stack alignItems="center" spacing={3}>
          <ConstructionIcon sx={{ fontSize: 64, color: '#0ea5e9' }} />
          <Typography variant="h5" fontWeight={700}>สร้างใบกำกับภาษี</Typography>
          <Typography color="text.secondary">ฟีเจอร์นี้กำลังอยู่ในระหว่างการพัฒนา</Typography>
          <Button
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={() => history.push('/sale/invoice')}
          >
            กลับรายการ
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
